import type { Dictionary, Translation } from '@/i18n/types';

const ro = {
  heroChip: 'HG nr. 630/2025 · Platformă națională',
  heroHeading: 'Cunoaștere agricolă, într-un singur loc',
  heroLead:
    'AKIS conectează fermierii cu consilierii agricoli, cercetătorii, instituțiile de formare și organizațiile profesionale. Găsiți un consilier în raionul dvs., înscrieți-vă la instruiri, consultați rezultate de cercetare și urmăriți măsurile de sprijin financiar.',
  heroFindAdvisor: 'Găsește un consilier agricol',
  heroExplore: 'Explorează platforma',
  heroStatsAria: 'Indicatori principali AKIS',
  heroStatAdvisors: 'consilieri atestați',
  heroStatTrainings: 'programe deschise',
  heroStatLibrary: 'resurse publice',
  heroSearchLabel: 'Caută în toate resursele platformei',
  heroSearchPlaceholder: 'ex. protecția plantelor, irigare prin picurare, subvenții 2026',
  heroSearchButton: 'Caută',
  chipGuides: 'Ghiduri tehnice',
  chipAdvisors: 'Consilieri',
  chipTrainings: 'Instruiri',
  chipResearch: 'Rezultate de cercetare',
  chipFunding: 'Subvenții',

  accountHeading: 'Contul dumneavoastră',
  accountAnonLead:
    'Autentificarea se face prin serviciul guvernamental M-Pass. La prima autentificare contul se creează automat.',
  accountSignedIn: 'Sunteți autentificat ca',
  accountMyCabinet: 'Cabinetul meu',
  accountRolesHeading: 'Cabinet personal pentru',
  roleFarmers: 'Fermieri',
  roleAdvisors: 'Consilieri agricoli',
  roleChambers: 'Camere agricole',
  roleCcar: 'CCAR',
  roleResearch: 'Organizații de cercetare',
  roleTraining: 'Instituții de formare',
  roleInputs: 'Companii de input',

  focusEyebrow: 'Agricultură în prim-plan',
  focusHeading: 'Cunoașterea se vede și în teren',
  focusLead:
    'Descoperiți resurse, instruiri și sprijin practic pentru fiecare etapă a sezonului agricol.',
  focusLibraryCat: 'Biblioteca AKIS',
  focusLibraryTitle: 'Ghiduri pentru recoltă și valorificare',
  focusLibraryCta: 'Explorează resursele',
  focusFundingCat: 'Sprijin financiar',
  focusFundingTitle: 'Urmăriți apelurile pentru investiții',
  focusFundingCta: 'Vezi finanțările',
  focusTrainingCat: 'Instruiri practice',
  focusTrainingTitle: 'Învățați direct din experiența specialiștilor',
  focusTrainingCta: 'Alege o instruire',

  catalogueSeeAll: 'Vezi întregul catalog',

  mapEyebrow: 'Informații geospațiale',
  mapHeading: 'Găsiți sprijin în raionul dumneavoastră',
  mapLead:
    'Harta reunește tot conținutul localizabil al platformei: consilieri, instituții, evenimente și intervenții teritoriale.',
  mapOpenFull: 'Deschide harta completă',
  mapByDistrict: 'Caută după raion',
  mapOpenInteractive: 'Deschide harta interactivă',
  mapCaption:
    'Strat raster pentru întreg teritoriul Republicii Moldova · vizualizare, amplasare și descrierea punctelor',

  trainingsEyebrow: 'Calendar instruiri',
  trainingsHeading: 'Sesiuni deschise pentru înscriere',
  trainingsNext: 'Următoarele instruiri',
  trainingsAll: 'Tot calendarul',
  trainingsSeeAll: 'Vezi toate programele de formare',
  trainingsOnline: 'Instruire · Online',
  trainingsOnSite: 'Instruire',

  eventsEyebrow: 'Calendar evenimente',
  eventsHeading: 'Transfer de cunoștințe',
  eventsNext: 'Evenimente apropiate',
  eventsAll: 'Tot calendarul',
  eventsSeeAll: 'Vezi calendarul național complet',

  newsEyebrow: 'Știri și articole',
  newsHeading: 'Ultimele noutăți',
  newsAll: 'Toate știrile',
  newsDefaultCategory: 'Noutăți',

  ctaEyebrow: 'Subvenții și granturi',
  ctaHeading: 'Nu ratați un apel de finanțare',
  ctaLead:
    'Catalogul măsurilor de sprijin financiar: domeniu, nivel de sprijin, calendar și stadiu — actualizat permanent.',
  ctaOpenCalls: 'Vezi apelurile deschise',
  ctaGuides: 'Ghiduri de aplicare',
  ctaSubscribeHeading: 'Notificări personalizate',
  ctaSubscribeLead:
    'Alegeți tematicile și raioanele de interes din cabinetul personal — notificările sosesc prin M-Notify.',
  ctaSubscribeButton: 'Abonează-mă (cu M-Pass)',
  ctaSubscribeSmall:
    'Prelucrăm datele conform Legii nr. 133/2011 și GDPR. Vă puteți dezabona oricând.',

  statsEyebrow: 'Gradul de utilizare',
  statsHeading: 'Platforma în cifre',
  statsLead: 'Date colectate de contorul de accesări al platformei, actualizate zilnic.',
  statsAdvisors: 'Consilieri agricoli atestați',
  statsLibrary: 'Resurse în biblioteca digitală',
  statsServices: 'Servicii de consiliere disponibile',
  statsResearch: 'Proiecte de cercetare conectate',

  emptyState: 'Nu există înregistrări deocamdată. Reveniți mai târziu.',
  kindDEMONSTRATION: 'Demonstrație practică',
  kindVISIT: 'Vizită tematică',
  kindWORKSHOP: 'Atelier',
  kindCONFERENCE: 'Conferință',
  kindTRAINING_EVENT: 'Sesiune de instruire',
  kindSCIENTIFIC: 'Eveniment științific',
} as const;

const en = {
  heroChip: 'Government Decision 630/2025 · National platform',
  heroHeading: 'Agricultural knowledge, in one place',
  heroLead:
    'AKIS connects farmers with agricultural advisers, researchers, training institutions and professional organisations. Find an adviser in your district, enrol in training, consult research results and follow the financial support measures.',
  heroFindAdvisor: 'Find an agricultural adviser',
  heroExplore: 'Explore the platform',
  heroStatsAria: 'Key AKIS indicators',
  heroStatAdvisors: 'attested advisers',
  heroStatTrainings: 'open programmes',
  heroStatLibrary: 'public resources',
  heroSearchLabel: 'Search all the resources on the platform',
  heroSearchPlaceholder: 'e.g. plant protection, drip irrigation, 2026 subsidies',
  heroSearchButton: 'Search',
  chipGuides: 'Technical guides',
  chipAdvisors: 'Advisers',
  chipTrainings: 'Training',
  chipResearch: 'Research results',
  chipFunding: 'Subsidies',

  accountHeading: 'Your account',
  accountAnonLead:
    'Sign-in goes through the M-Pass government service. Your account is created automatically at the first sign-in.',
  accountSignedIn: 'You are signed in as',
  accountMyCabinet: 'My account',
  accountRolesHeading: 'A personal account for',
  roleFarmers: 'Farmers',
  roleAdvisors: 'Agricultural advisers',
  roleChambers: 'Agricultural chambers',
  roleCcar: 'CCAR',
  roleResearch: 'Research organisations',
  roleTraining: 'Training institutions',
  roleInputs: 'Input companies',

  focusEyebrow: 'Agriculture in focus',
  focusHeading: 'Knowledge shows in the field too',
  focusLead:
    'Find resources, training and practical support for every stage of the agricultural season.',
  focusLibraryCat: 'AKIS library',
  focusLibraryTitle: 'Guides for harvesting and adding value',
  focusLibraryCta: 'Explore the resources',
  focusFundingCat: 'Financial support',
  focusFundingTitle: 'Follow the calls for investment',
  focusFundingCta: 'See the funding',
  focusTrainingCat: 'Practical training',
  focusTrainingTitle: 'Learn directly from specialists’ experience',
  focusTrainingCta: 'Choose a course',

  catalogueSeeAll: 'See the whole catalogue',

  mapEyebrow: 'Geospatial information',
  mapHeading: 'Find support in your district',
  mapLead:
    'The map brings together all the locatable content on the platform: advisers, institutions, events and territorial interventions.',
  mapOpenFull: 'Open the full map',
  mapByDistrict: 'Search by district',
  mapOpenInteractive: 'Open the interactive map',
  mapCaption:
    'Raster layer for the whole territory of the Republic of Moldova · view, placement and point descriptions',

  trainingsEyebrow: 'Training calendar',
  trainingsHeading: 'Sessions open for enrolment',
  trainingsNext: 'Upcoming training',
  trainingsAll: 'The whole calendar',
  trainingsSeeAll: 'See all training programmes',
  trainingsOnline: 'Training · Online',
  trainingsOnSite: 'Training',

  eventsEyebrow: 'Events calendar',
  eventsHeading: 'Knowledge transfer',
  eventsNext: 'Upcoming events',
  eventsAll: 'The whole calendar',
  eventsSeeAll: 'See the full national calendar',

  newsEyebrow: 'News and articles',
  newsHeading: 'Latest news',
  newsAll: 'All news',
  newsDefaultCategory: 'News',

  ctaEyebrow: 'Subsidies and grants',
  ctaHeading: 'Do not miss a funding call',
  ctaLead:
    'The catalogue of financial support measures: field, support level, timetable and stage — kept up to date.',
  ctaOpenCalls: 'See the open calls',
  ctaGuides: 'Application guides',
  ctaSubscribeHeading: 'Personalised notifications',
  ctaSubscribeLead:
    'Choose the topics and districts you care about from your personal account — notifications arrive via M-Notify.',
  ctaSubscribeButton: 'Subscribe (with M-Pass)',
  ctaSubscribeSmall:
    'We process data under Law 133/2011 and the GDPR. You can unsubscribe at any time.',

  statsEyebrow: 'Usage',
  statsHeading: 'The platform in figures',
  statsLead: 'Data from the platform’s access counter, updated daily.',
  statsAdvisors: 'Attested agricultural advisers',
  statsLibrary: 'Resources in the digital library',
  statsServices: 'Advisory services available',
  statsResearch: 'Research projects connected',

  emptyState: 'No records yet. Please check back later.',
  kindDEMONSTRATION: 'Practical demonstration',
  kindVISIT: 'Thematic visit',
  kindWORKSHOP: 'Workshop',
  kindCONFERENCE: 'Conference',
  kindTRAINING_EVENT: 'Training session',
  kindSCIENTIFIC: 'Scientific event',
} satisfies Translation<keyof typeof ro>;

export const publicHome = { ro, en } satisfies Dictionary;

export type PublicHomeKey = keyof typeof ro;
